import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AdminMainComponent } from './admin-main/admin-main.component';
import { PagesComponent } from './pages/pages.component';
import { UserProfileComponent } from './../common-module/user-profile/user-profile.component';
import { MenuComponent } from './menu/menu.component';
import { CustomerComponent } from './customer/customer.component';
import { CreateModuleComponent } from './create-module/create-module.component';
import { CreatePageComponent } from './create-page/create-page.component';
import { AdminPageComponent } from './admin-page/admin-page.component';
import { CreateMenuComponent } from './menu/create-menu/create-menu.component';
import { AuditTrialAdminComponent } from './audit-trial-admin/audit-trial-admin.component';
import { MenuCreatePageComponent } from './menu-create-page/menu-create-page.component';
import { CreateDashboardComponent } from './create-dashboard/create-dashboard.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { ModulesComponent } from './modules/modules.component';
import { MoreInfoTabSettingComponent } from './more-info-tab-setting/more-info-tab-setting.component'
import { NotfoundComponent } from '../common-module/notfound/notfound.component';

export const DASHBOARD_ROUTES: Routes = [{
  path: '',
  data: {
    breadcrumb: 'Dashboard'
  },
  component: DashboardComponent,
  children: [
    {
      path: '',
      data: {
        breadcrumb: null
      },
      children: [
        {
          path: '',
          data: {
            breadcrumb: null
          },
          component: AdminMainComponent,
        },
        {
          path: 'createmodule',
          data: {
            breadcrumb: 'Create Module'
          },
          component: CreateModuleComponent
        },
        {
          path: 'createmenu',
          data: {
            breadcrumb: 'Create Menu'
          },
          component: CreateMenuComponent
        },
        {
          path: 'menucreatepage',
          data: {
            breadcrumb: 'Create Page'
          },
          //component: CreatePageComponent
          component: MenuCreatePageComponent
        }
      ]
    },
    {
      path: 'pages',
      data: {
        breadcrumb: 'Pages'
      },
      children: [
        {
          path: '',
          data: {
            breadcrumb: null
          },
          component: PagesComponent
        },
        {
          path: 'create-page',
          data: {
            breadcrumb: 'Create Page'
          },
          component: CreatePageComponent
        },
        {
          path: 'moreInfoTab',
          data: {
            breadcrumb: 'MoreInfo'
          },
          component: MoreInfoTabSettingComponent
        },
        {
          path: 'main-page/:page_name',
          data: {
            breadcrumb: 'Main Page Layout'
          },
          component: AdminPageComponent
        },
        {
          path: 'create-dashboard',
          data: {
            breadcrumb: 'Create Dashboard'
          },
          component: CreateDashboardComponent
        }
      ]
    },
    // {
    //   path: 'viewprofile',
    //   data: {
    //     breadcrumb: 'View Profile'
    //   },
    //   component: UserProfileComponent
    // },
    {
      path: 'menu',
      data: {
        breadcrumb: 'Menus'
      },
      children: [
        {
          path: '',
          data: {
            breadcrumb: null
          },
          component: MenuComponent,
        },
        {
          path: 'createmenu',
          data: {
            breadcrumb: 'Create Menu'
          },
          component: CreateMenuComponent
        }
      ]
    },
    {
      path: 'module',
      data: {
        breadcrumb: 'Modules'
      },
      children: [
        {
          path: '',
          data: {
            breadcrumb: null
          },
          component: ModulesComponent,
        }
      ]
    },
    {
      path: 'customer',
      data: {
        breadcrumb: 'Customers'
      },
      component: CustomerComponent
    },
    {
      path: 'audittrial',
      data: {
        breadcrumb: 'Audit Trial'
      },
      component: AuditTrialAdminComponent
    },
    {
      path: 'admin-dashboard',
      data: {
        breadcrumb: 'Reports'
      },
      children: [
        {
          path: '',
          data: {
            breadcrumb: null
          },
          component: AdminDashboardComponent
        },
        {
          path: 'create-dashboard',
          data: {
            breadcrumb: 'Create Dashboard'
          },
          component: CreateDashboardComponent
        },
        {
          path: 'dashboard-page/:page_name',
          data: {
            breadcrumb: 'Dashboard Page Layout'
          },
          component: DashboardPageComponent
        }
      ]
    },
    {
      path: '404',
      data: {
        breadcrumb: 'Not Found'
      },
      component: NotfoundComponent
    }, {
      path: '',
      redirectTo: '',
      pathMatch: 'full'
    }, {
      path: '**',
      redirectTo: '404'
    }
  ]
}];


